var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.672,6.092c-2.615-2.489-6.729-2.489-9.344,0-2.793,2.659-2.644,7.184.083,9.91l2.482,2.482c1.33,1.33,2.883,1.33,3.847.366.857-.857,1.906-1.906,2.848-2.848,2.727-2.727,2.877-7.251.083-9.91ZM12,14.323c-1.833,0-3.319-1.486-3.319-3.319s1.486-3.319,3.319-3.319,3.319,1.486,3.319,3.319-1.486,3.319-3.319,3.319Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.b93f4f452e384f1b22fbc855fed210d3.svg";
export { ForwardRef as ReactComponent };